import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Seo from '@/seo/Seo';

const galleryImages = Array.from({ length: 31 }, (_, index) => index + 1)
  .filter((number) => number !== 17)
  .map((number) => {
  const imageNumber = String(number).padStart(2, '0');
  return {
    src: `/assets/gallery/whatsapp-${imageNumber}.jpg`,
    alt: `Global79 Lojistik galeri görseli ${number}`,
  };
});

export default function GalleryPage() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Seo
        title="Galeri | Global79 Lojistik"
        description="Global79 Lojistik galeri sayfasında operasyonlarımızdan ve taşımacılık süreçlerimizden görselleri inceleyin."
        path="/galeri"
        keywords="Global79 galeri, lojistik görselleri, taşımacılık fotoğrafları"
        ogImage="/assets/gallery/whatsapp-01.jpg"
      />

      <Navbar />

      <section className="pt-32 pb-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-12">
            <span className="text-orange-500 text-sm font-bold uppercase tracking-widest mb-3 block">
              Galeri
            </span>
            <h1
              className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Operasyonlarımızdan Kareler
            </h1>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {galleryImages.map((image) => (
              <figure
                key={image.src}
                className="overflow-hidden rounded-2xl bg-white border border-gray-200 shadow-sm"
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  loading="lazy"
                  className="w-full h-72 object-cover hover:scale-105 transition-transform duration-300"
                />
              </figure>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
